import React, { Component } from 'react'
import Slide from 'react-reveal/Slide';
import CountUp from 'react-countup';

export class StatsSection extends Component {
    render() {
        return (
            <section className="stats-section" id="about">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                                <div className="section-title text-center">
                                    <h2>DCH 2019 in Numbers</h2>
                                    <p>Thank you all for your participation</p>
                                </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="row mb-d-30">
                            <div className="col-lg-3">
                                <div className="stats-card">
                                    <div className="card-head">
                                        <h2>
                                            <CountUp className="big-txt" end={200} duration={10}></CountUp>
                                            <br />
                                            <span className="small-title">Workshop Attendant</span>
                                        </h2>
                                    </div>
                                    <div className="card-content"></div>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="stats-card">
                                    <div className="card-head">
                                        <h2>
                                            <CountUp className="big-txt" end={166} duration={10}></CountUp>
                                            <br />
                                            <span className="small-title">Teams Registered</span>
                                        </h2>
                                    </div>
                                    <div className="card-content"></div>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="stats-card">
                                    <div className="card-head">
                                        <h2>
                                            <CountUp className="big-txt" end={422} duration={10}></CountUp>
                                            <br />
                                            <span className="small-title">Participant Submitted</span>
                                        </h2>
                                    </div>
                                    <div className="card-content"></div>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="stats-card">
                                    <div className="card-head">
                                        <h2>
                                            <CountUp className="big-txt" end={50} duration={10}></CountUp>
                                            <br />
                                            <span className="small-title">Teams Qualified</span>
                                        </h2>
                                    </div>
                                    <div className="card-content"></div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                
            </section>
        )
    }
}

export default StatsSection
